export const baseURLCommon = '//restapi.xuanwonainiu.com'
export const APIURL = '//apiyhact.ab1a.cn'
export const APIURLNEW = '//apiyhact.ab1a.cn'
export const APIURLCPS = '//cps.ab1a.cn'



export const validDomain = 'yhact.ab1l.cn;yhact.ab0t.cn;yhact.ab1c.cn;yhact.ab0p.cn;yhact.ab1m.cn;yhact.ab1n.cn;yhact.ab0v.cn'.split(';')

export const CAT_ENUM = [
  {
    value: 0,
    name: '全部'
  },
  {
    value: 11,
    name: '美食'
  },
  {
    value: 4,
    name: '美妆'
  },
  {
    value: 1,
    name: '女装'
  },
  {
    value: 2,
    name: '男装'
  },
  {
    value: 3,
    name: '内衣'
  },
  {
    value: 9,
    name: '母婴'
  },
  {
    value: 10,
    name: '居家'
  },
  {
    value: 12,
    name: '数码'
  },
  {
    value: 13,
    name: '家电'
  },
  {
    value: 5,
    name: '配饰'
  },
  {
    value: 6,
    name: '鞋品'
  },
  {
    value: 7,
    name: '箱包'
  },
  {
    value: 8,
    name: '儿童'
  },
  {
    value: 15,
    name: '车品'
  },
  {
    value: 16,
    name: '文体'
  },
  {
    value: 17,
    name: '宠物'
  },
  {
    value: 14,
    name: '其他'
  },
]
